import React, { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AddScreenTitle from "../components/AddScreenTitle";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import MainLayout from "../components/MainLayout";
import RadioGroup from "../ReusableComponents/RadioButton";
import TextArea from "../ReusableComponents/TextArea";
import { mainTable } from "../css/Common";
import Buttons from "../components/Buttons";
import FileUpload from "../ReusableComponents/FileUpload";
import GridPage from "../components/GridPage";
import { StaffMasterHeader } from "../components/HeaderAttribute";
import { SalaryPayHeader } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import StaffMasterPopup from "../popup-containers/StaffMasterPopup";
import toast from "react-hot-toast";

import GridPageWithCheckBox from "../components/GridPageWithCheckBox";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import { Regex } from "lucide-react";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

// Utility function to format date to YYYY-MM-DD
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return ""; // Handle invalid date
  return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD
};

const StaffMaster = () => {
  const [formFields, setFormFields] = useState({
    firstName: "",
    lastName: "",
    fatherName: "",
    employeeID: "",
    position: "",
    idProof: "",
    idNumber: "",
    email: "",
    gender: "",
    dateOfBirth: "",
    contactNumber: "",
    emergencycontactNumber: "",
    bloodGroup: "",
    hiringDate: "",
    address: "",
    contactName: "",
    workShift: "",
    relation: "",
    emergencyaddress: "",
    aadhaarNumber: "",
    panNumber: "",
    bankName: "",
    bankBranch: "",
    ifscCode: "",
    state: "",
    country: "",
    city: "",
    showImage: "",
    mstGradeId: "",
    mstSalaryId: "",
  });
  //Field Labels
  const fieldLabels = {
    firstName: " First Name",
    fatherName: "Father Name",
    lastName: "Last Name",
    employeeID: "Employee ID",
    idNumber: "ID Number",
    idProof: "ID Proof",
    position: "Position",
    gender: "Gender",
    dateOfBirth: "Date of Birth",
    contactNumber: "Contact Number",
    bloodGroup: "Blood Group",
    address: "Address",
    email: "Email",
    workShift: "Work Shift",
    hiringDate: "Hiring Date",
    contactName: "Contact Name",
    relation: "Relation",
    aadhaarNumber: "Aadhaar Number",
    panNumber: "PAN Number",
    bankName: "Bank Name",
    bankBranch: "Bank Branch",
    ifscCode: "IFSC Code",
    accountNumber: "Account Number",
    state: "State",
    country: "Country",
    city: "city",
  };
  //Error messages
  const [errors, setErrors] = useState({
    firstName: "",
    fatherName: "",
    lastName: "",
    employeeID: "",
    idNumber: "",
    idProof: "",
    position: "",
    gender: "",
    hiringDate: "",
    state: "",
    country: "",
    city: "",
    dateOfBirth: "",
    bloodGroup: "",
    emergencycontactNumber: "",
    contactNumber: "",
    workShift: "",
    relation: "",
    aadhaarNumber: "",
    panNumber: "",
    bankBranch: "",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    showImage: "",
    imageUploadedError: "",
    salarySelection: "",
  });
  // usestate values
  const [rowIndex, setRowIndex] = useState(null);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [bindStaffMasterData, setbindStaffMasterData] = useState([]);
  const [idProofType, setidProofType] = useState([]);
  const [Position, setPosition] = useState([]);
  const [shiftName, setshiftName] = useState([]);
  const [state, setState] = useState([]);
  const [BloodGroup, setBloodGroup] = useState([]);
  const [MstStaffId, setMstStaffId] = useState(0);
  const [gender, setgender] = useState([]);
  const [popUpData, setPopUpData] = useState(null);
  const [popupDataDD, setPopupDataDD] = useState([]);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedRowTableData, setSelectedRowTableData] = useState([]);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [BindSalaryPayData, setBindSalaryPayData] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([]);
  const [cityBindDD, setCityBindDD] = useState([]);

  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);

  var createdBy = sessionStorage.getItem("createdBy"); // user session
  var mstClientId = sessionStorage.getItem("MstClientId");

  // bind gird datas
  useEffect(() => {
    BindStaffMasterData();
  }, []);
  // Fetch data from API and bind to table
  const BindStaffMasterData = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    setIsLoading(true);
    const response = await BindPostAPI(data, "StaffMasterAPI/ BindStaffMaster");
    console.log("API Response:", response);

    if (response && response.data) {
      setbindStaffMasterData(response.data.Table);

      const idProofTypeData = response.data.Table2.map((item) => ({
        value: item.MstIdProofTypeId,
        label: item.IdProofType,
      }));

      setidProofType(idProofTypeData);

      const positionData = response.data.Table1.map((item) => ({
        value: item.MstPositionId,
        label: item.Position,
      }));

      setPosition(positionData);

      const shiftNameData = response.data.Table4.map((item) => ({
        value: item.MstShiftId,
        label: item.ShiftName,
      }));

      setshiftName(shiftNameData);

      const bloodGroupData = response.data.Table3.map((item) => ({
        value: item.MstBloodGroup,
        label: item.BloodGroup,
      }));

      setBloodGroup(bloodGroupData);

      const genderData = response.data.Table5.map((item) => ({
        value: item.MstGenderId,
        label: item.Gender,
      }));

      setgender(genderData);

      setBindSalaryPayData(response.data.Table6);

      // New: Country and State data (assuming they come from the API)
      const countryData =
        response.data.Table7?.map((item) => ({
          value: item.MstCountryId,
          label: item.CountryName,
        })) ||
        [
          // { value: 1, label: "India" },
          // { value: 2, label: "USA" },
          // // Add more countries as needed
        ];
      setCountryBindDD(countryData);

      const stateData = response.data.Table8?.map((item) => ({
        value: item.MstStateId,
        label: item.State,
        countryId: item.MstCountryId, // Assuming state data includes country reference
      }));
      setState(stateData);

      // City data (static or from API)
      const cityData =
        response.data.Table6?.map((item) => ({
          value: item.MstCityId,
          label: item.City,
          stateId: item.MstStateId, // Assuming city data includes state reference
        })) ||
        [
          // { value: 1, label: "Chennai", stateId: 1 },
          // { value: 2, label: "Coimbatore", stateId: 1 },
          // { value: 3, label: "Kochi", stateId: 2 },
          // { value: 4, label: "Los Angeles", stateId: 3 },
          // // Add more cities as needed
        ];
      setCityBindDD(cityData);

      setIsLoading(false);
    } else {
      setbindStaffMasterData([]);
    }
  };

  // const MapSalary = () => {
  //     if (!showTable) {
  //         const dummyData = [
  //             {
  //                 grade: '1',
  //                 gross: '7000',
  //                 deduction: '2000',
  //                 total: '5000',
  //             },
  //             {
  //                 grade: '2',
  //                 gross: '12000',
  //                 deduction: '2000',
  //                 total: '10000',
  //             },

  //             {
  //                 grade: '3',
  //                 gross: '14000',
  //                 deduction: '2000',
  //                 total: '12000',
  //             }

  //         ];
  //         setBindSalaryPayData(dummyData);
  //         setShowTable(true);
  //     } else {
  //         setShowTable(false);
  //     }
  // };

  // const [showTable, setShowTable] = useState(false);

  //handlechange for Radio Button
  const handleGenderChange = (value) => {
    setFormFields({
      ...formFields,
      gender: value,
    });

    if (value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        gender: "",
      }));
    }
  };

  // Handle changes in gender fields
  // const handleGenderChange = (value) => {
  //     // Find the gender object that matches the selected label
  //     const selectedGender = gender.find(g => g.label === value);
  //     // Store both the ID and label in formFields
  //     setFormFields(prev => ({
  //         ...prev,
  //         gender: selectedGender ? selectedGender.value : '',
  //         genderLabel: value // Optional: store the label if needed for display
  //     }));
  // };

  // Validation for onblur
  const handleBlur = (e) => {
    const { name, value, type } = e.target;
    let error = "";

    if (value.trim() === "") {
      const fieldLabel = fieldLabels[name] || name;
      error = `${type == "select-one" ? "Select" : "Enter"} ${fieldLabel}`;
    } else if (fieldValidationMap[name] && value.trim() !== "") {
      const { regex, error: patternError } = fieldValidationMap[name];
      if (!regex.test(value)) {
        error = patternError;
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  // const handleBlur = (e) => {
  //     const { name, value, type } = e.target;
  //     let error = '';

  //     const trimmedValue = value.trim();
  //     const fieldLabel = fieldLabels[name] || name;

  //     if (trimmedValue === '') {
  //         error = `${type === 'select-one' ? 'Select' : 'Enter'} ${fieldLabel}`;
  //     } else if (fieldRegexMap[name]) {
  //         const pattern = fieldRegexMap[name];
  //         if (!pattern.test(trimmedValue)) {
  //             error = `Invalid ${fieldLabel}`;
  //         }
  //     }
  //     setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         [name]: error,
  //     }));
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  //Add Functionality
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setFormFields({
      firstName: "",
      fatherName: "",
      employeeID: "EMP",
      idNumber: "",
      idProof: "",
      position: "",
      gender: "",
      hiringDate: "",
      dateOfBirth: "",
      bloodGroup: "",
      contactNumber: "",
      workShift: "",
      relation: "",
      country:1,
      aadhaarNumber: "",
      panNumber: "",
      bankName: "",
      accountNumber: "",
      ifscCode: "",
    });
  };
  //Cancel functionality
  const cancel = () => {
    setFormFields({
      firstName: "",
      lastName: "",
      fatherName: "",
      employeeID: "",
      position: "",
      idProof: "",
      idNumber: "",
      email: "",
      gender: "",
      dateOfBirth: "",
      contactNumber: "",
      emergencycontactNumber: "",
      bloodGroup: "",
      hiringDate: "",
      address: "",
      contactName: "",
      workShift: "",
      relation: "",
      emergencyaddress: "",
      aadhaarNumber: "",
      panNumber: "",
      bankName: "",
      bankBranch: "",
      ifscCode: "",
      showImage: "",
    });
    setErrors({
      firstName: "",
      fatherName: "",
      lastName: "",
      employeeID: "",
      idNumber: "",
      idProof: "",
      position: "",
      gender: "",
      hiringDate: "",
      dateOfBirth: "",
      bloodGroup: "",
      emergencycontactNumber: "",
      contactNumber: "",
      workShift: "",
      relation: "",
      aadhaarNumber: "",
      panNumber: "",
      bankBranch: "",
      bankName: "",
      accountNumber: "",
      ifscCode: "",
    });
    BindStaffMasterData();

    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setpopUpOpen(false);
    // setShowTable(false);
    setSubmitBtnDisabled(false);
    setIsLoading(false);
  };

  //Edit functionality
  const handleEdit = (rowIndex) => {
    const staff = bindStaffMasterData[rowIndex];
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstStaffId(staff.MstStaffId);

    const selectedCountryId = staff.MstCountryId;
    const selectedStateId = staff.MstStateId;

    const filteredStateOptions = state.filter(
      (s) => s.countryId === selectedCountryId
    );
    const filteredCityOptions = cityBindDD.filter(
      (c) => c.stateId === selectedStateId
    );

    setFilteredStates(filteredStateOptions);
    setFilteredCities(filteredCityOptions);

    setFormFields({
      ...formFields,
      employeeID: staff.EmployeeID,
      firstName: staff.FirstName,
      lastName: staff.LastName,
      fatherName: staff.FatherName,
      position: staff.MstPositionId,
      gender: parseInt(staff.MstGenderId),
      contactNumber: staff.ContactNumber,
      idProof: staff.MstIdProofTypeId,
      idNumber: staff.IdNumber,
      dateOfBirth: staff.DateOfBirth?.split("T")[0],
      bloodGroup: staff.MstBloodGroup,
      hiringDate: staff.HiringDate?.split("T")[0],
      address: staff.Address,
      email: staff.Email,
      workShift: staff.MstShiftId,
      contactName: staff.ContactName,
      relation: staff.Relation,
      emergencyaddress: staff.EmergencyAddress,
      emergencycontactNumber: staff.EmergencyContactNumber || "",
      aadhaarNumber: staff.AadhaarNumber,
      panNumber: staff.PanNumber,
      bankName: staff.BankName,
      bankBranch: staff.BankBranch,
      ifscCode: staff.IFSCCode,
      accountNumber: staff.AccountNumber,
      showImage: staff.Image,
      mstGradeId: staff.MstGradeId,
      mstSalaryId: staff.MstSalaryId,
      country: selectedCountryId || "",
      state: selectedStateId || "",
      city: staff.MstCityId || "",
    });

    const filterIssueIdIndex = BindSalaryPayData.reduce(
      (indices, obj, index) => {
        if (obj.Grade === staff.MstGradeId) {
          indices.push(index);
        }
        return indices;
      },
      []
    );
    setSelectedRows(filterIssueIdIndex);
  };

  //Popup Functonality
  const handleStaff = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    const rowData = bindStaffMasterData[rowIndex];
    setMstStaffId(bindStaffMasterData[rowIndex].MstStaffId);

    const staffGradeId = rowData.MstGradeId;
    const MstGradeId = bindStaffMasterData[rowIndex].MstGradeId;

    const matchedSalaryIndex = BindSalaryPayData.filter(
      (item) => item.Grade == MstGradeId
    );

    setPopUpData(rowData);
    setPopupDataDD({
      idProofType,
      position: Position,
      shiftName,
      bloodGroup: BloodGroup,
      gender,
      // cityBindDD,
      // state,
      // countryBindDD
    });

    setSelectedRows([matchedSalaryIndex]);
    setCheckBoxStatus([matchedSalaryIndex]);
    setBindSalaryPayData(matchedSalaryIndex);
  };

  const handleCancel = () => {
    setFormFields({
      firstName: "",
      fatherName: "",
      lastName: "",
      employeeID: "EMP",
      position: "",
      idProof: "",
      idNumber: "Id Number",
      email: "",
      gender: "",
      dateOfBirth: "",
      contactNumber: "",
      bloodGroup: "",
      hiringDate: "",
      address: "",
      contactName: "",
      workShift: "",
      emergencyaddress: "",
      aadhaarNumber: "",
      panNumber: "",
      bankName: "",
      accountNumber: "",
      ifscCode: "",
    });
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setErrors(emptyErrors);
    // setShowTable(false)
    setSubmitBtnDisabled(false);
  };

  const emptyErrors = {
    staffName: "",
    staffType: "",
    dob: "",
    gender: "",
    contactNo: "",
    email: "",
    address: "",
    bloodGroup: "",
    emergencyContact: "",
    emergencyContactNo: "",
    contactName: "",
    relation: "",
    emergencyaddress: "",
  };

  // Define required fields with their types
  const requiredFields = [
    { field: "firstName", type: "text" },
    { field: "fatherName", type: "text" },
    { field: "employeeID", type: "text" },
    // { field: 'idProof', type: 'select-one' },
    // { field: 'idNumber', type: 'text' },
    { field: "position", type: "select-one" },
    { field: "gender", type: "radio" },
    { field: "dateOfBirth", type: "date" },
    { field: "contactNumber", type: "text" },
    { field: "bloodGroup", type: "select-one" },
    { field: "hiringDate", type: "date" },
    { field: "workShift", type: "select-one" },
    { field: "contactName", type: "text" },
    { field: "relation", type: "text" },
    { field: "emergencycontactNumber", type: "text" },
    { field: "aadhaarNumber", type: "text" },
    { field: "panNumber", type: "text" },
    { field: "bankName", type: "text" },
    { field: "accountNumber", type: "text" },
    { field: "ifscCode", type: "text" },
    { field: "address", type: "text" },
    { field: "country", type: "select-one" },
    { field: "state", type: "select-one" },
    { field: "city", type: "select-one" },
  ];
  // Regex validation
  const phoneRegex = /^[6-9]\d{9}$/; // Indian mobile numbers
  const aadhaarRegex = /^[2-9]{1}[0-9]{11}$/; // Aadhaar (not starting with 0/1)
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN format
  // const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/; // IFSC code
  const nameRegex = /^[A-Za-z\s]+$/; // Only alphabets and spaces
  const accountNumberRegex = /^\d{9,18}$/; // 9 to 18 digit bank account

  const fieldValidationMap = {
    firstName: {
      regex: nameRegex,
      error: "Only alphabets are allowed",
    },
    lastName: {
      regex: nameRegex,
      error: "Only alphabets are allowed",
    },
    fatherName: {
      regex: nameRegex,
      error: "Only alphabets are allowed",
    },
    contactNumber: {
      regex: phoneRegex,
      error: "Enter Valid Mobile Number",
    },
    emergencycontactNumber: {
      regex: phoneRegex,
      error: "Enter Valid Mobile Number",
    },
    aadhaarNumber: {
      regex: aadhaarRegex,
      error: "Must be a valid 12-digit Aadhaar number",
    },
    panNumber: {
      regex: panRegex,
      error: "Invalid PAN format (e.g., ABCDE1234F)",
    },
    // ifscCode: {
    //     regex: ifscRegex,
    //     error: 'Invalid IFSC format (e.g., SBIN0001234)'
    // },
    accountNumber: {
      regex: accountNumberRegex,
      error: "Account number must be 9-18 digits",
    },

    contactName: {
      regex: nameRegex,
      error: "Only alphabets are allowed",
    },
    relation: {
      regex: nameRegex,
      error: "Only alphabets are allowed",
    },
  };

  //Validation
  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    requiredFields.forEach(({ field, type }) => {
      const value = formFields[field];
      let isEmpty = false;

      if (type === "radio") {
        isEmpty = value === undefined || value === null || value === "";
      } else if (type === "select-one") {
        isEmpty =
          value === undefined ||
          value === null ||
          value === "" ||
          value === "0";
      } else {
        isEmpty =
          value === undefined ||
          value === null ||
          value.toString().trim() === "";
      }

      if (isEmpty) {
        const label = fieldLabels[field] || field;
        newErrors[field] = `${
          type === "select-one" ? "Select" : "Enter"
        } ${label}`;
        isValid = false;
      }
    });

    // Then validate regex patterns for non-empty fields
    Object.keys(fieldValidationMap).forEach((field) => {
      const value = formFields[field];
      if (value && value.trim() !== "") {
        // Only validate if field has value
        const { regex, error } = fieldValidationMap[field];
        if (!regex.test(value)) {
          newErrors[field] = error;
          isValid = false;
        }
      }
    });

    // Date validation
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize to start of day

    // Date of Birth validation
    if (formFields.dateOfBirth) {
      const dob = new Date(formFields.dateOfBirth);
      if (dob >= today) {
        newErrors.dateOfBirth = "Date of Birth must be in the past";
        isValid = false;
      }

      // Additional check: person should be at least 18 years old
      const minAgeDate = new Date();
      minAgeDate.setFullYear(today.getFullYear() - 18);
      if (dob > minAgeDate) {
        newErrors.dateOfBirth = "Staff must be at least 18 years old";
        isValid = false;
      }
    }

    // // Hiring Date validation
    // if (formFields.hiringDate) {
    //     const hiringDate = new Date(formFields.hiringDate);

    //     if (hiringDate > today) {
    //         newErrors.hiringDate = 'Hiring Date cannot be in the future';
    //         isValid = false;
    //     }

    //     // Compare with Date of Birth if both exist
    //     if (formFields.dateOfBirth) {
    //         const dob = new Date(formFields.dateOfBirth);
    //         if (hiringDate < dob) {
    //             newErrors.hiringDate = 'Hiring Date must be after Date of Birth';
    //             isValid = false;
    //         }

    //         // Additional check: hiring at least 16 years after birth
    //         const minHireAgeDate = new Date(dob);
    //         minHireAgeDate.setFullYear(dob.getFullYear() + 16);
    //         if (hiringDate < minHireAgeDate) {
    //             newErrors.hiringDate = 'Staff must be at least 16 years old when hired';
    //             isValid = false;
    //         }
    //     }
    // }

    // Validate image
    if (!formFields.showImage) {
      newErrors.showImage = "Please upload an image";
      newErrors.imageUploadedError = "Please upload an image";
      isValid = false;
    }

    // if (selectedRows.length === 0) {
    //     newErrors.salarySelection = 'Please select a salary grade';
    //     isValid = false;
    // }

    setErrors(newErrors);
    return isValid;
  };

  // const validateForm = () => {
  //     const newErrors = {};
  //     let isValid = true;

  //     requiredFields.forEach(({ field, type }) => {
  //         const value = formFields[field];
  //         let isEmpty = false;

  //         if (type === 'radio') {
  //             isEmpty = value === undefined || value === null || value === '';
  //         } else if (type === 'select-one') {
  //             isEmpty = value === undefined || value === null || value === '' || value === '0';
  //         } else {
  //             isEmpty = value === undefined || value === null || value.toString().trim() === '';
  //         }

  //         const label = fieldLabels[field] || field;

  //         if (isEmpty) {
  //             newErrors[field] = `${type === 'select-one' ? 'Select' : 'Enter'} ${label}`;
  //             isValid = false;
  //         } else if (fieldRegexMap[field]) {
  //             const pattern = fieldRegexMap[field];
  //             if (!pattern.test(value)) {
  //                 newErrors[field] = `Invalid ${label}`;
  //                 isValid = false;
  //             }
  //         }
  //     });

  //     setErrors(newErrors);
  //     return isValid;
  // };

  //

  //Handles insert, update, delete, active, and inactive operations
  const handleSubmit = async (rowIndex, flag) => {
    debugger;

    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();
    if (flag == 1 || flag == 2) {
      // Add or Edit

      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);

        const data = {
          mststaffId: MstStaffId ? MstStaffId : 0,
          mstClientId: mstClientId,
          firstName: formFields.firstName,
          lastName: formFields.lastName,
          fatherName: formFields.fatherName,
          employeeID: formFields.employeeID,
          mstPositionId: parseInt(formFields.position, 10),
          // mstIdProofTypeId: parseInt(formFields.idProof, 10),
          // idNumber: parseInt(formFields.idNumber, 10),
          email: formFields.email,
          mstGenderId: formFields.gender,
          dateOfBirth: formFields.dateOfBirth,
          contactNumber: formFields.contactNumber,
          emergencycontactNumber: formFields.emergencycontactNumber,
          mstBloodGroup: parseInt(formFields.bloodGroup, 10),
          hiringDate: formFields.hiringDate,
          address: formFields.address,
          contactName: formFields.contactName,
          mstShiftId: parseInt(formFields.workShift, 10),
          // emergencyaddress: formFields.emergencyaddress,
          aadhaarNumber: formFields.aadhaarNumber,
          panNumber: formFields.panNumber,
          bankName: formFields.bankName,
          bankBranch: formFields.bankBranch,
          ifscCode: formFields.ifscCode,
          accountNumber: formFields.accountNumber,
          relation: formFields.relation,
          image: formFields.showImage,
          // mstGradeId: formFields.mstGradeId,
          //  mstSalaryId: formFields.mstSalaryId,
          mstCityId: parseInt(formFields.city, 10) || 0,
          mstCountryId: parseInt(formFields.country, 10) || 0,
          mstStateId: parseInt(formFields.state, 10) || 0,

          createdBy: parseInt(createdBy, 10),
          flag: flag,
        };

        const response = await IUDAPI(data, "StaffMasterAPI/IUDStaffMaster");

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Staff data inserted successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Staff data insert failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Staff data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Staff data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        mstStaffId: MstStaffId ? MstStaffId : 0,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(data, "StaffMasterAPI/IUDStaffMaster");
      // Delete (3), Block (4), Unblock (5)
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Staff data deleted successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete Staff data. 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Staff data Inactivated successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Staff data Inactivated failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Staff data activated successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Staff data activated failed! 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }
  };

  // handles FileUpload
  const handleShowImage = (showImage1) => {
    setFormFields({
      ...formFields,
      showImage: showImage1,
    });
    setErrors({ ...errors, imageUploadedError: "" });
  };

  //checkBoxStatus
  const handle1 = (value) => {
    if (value.length === 0) return;

    const selectedIndex = value[0];
    const selectedSalaryObj = BindSalaryPayData[selectedIndex];

    if (!selectedSalaryObj) return;

    setFormFields({
      ...formFields,
      mstSalaryId: selectedSalaryObj.MstSalaryId,
      mstGradeId: selectedSalaryObj.Grade,
    });

    setSelectedRows(value);
    setCheckBoxStatus(value);
  };
  return (
    <>
      <MainLayout pageName="2">
        <Loader
          isVisible={isLoading}
          size="h-20 w-20"
          color="border-t-black"
          blur={true}
        />
        {visibleTable && (
          <GridPage
            title={"Staffs"}
            header={StaffMasterHeader}
            records={bindStaffMasterData}
            handleEdit={handleEdit}
            handleAction={handleStaff}
            showAdd={showAdd}
            blockView={true}
          />
        )}
        {visibleAdd && (
          <>
            <div className="overflow-hidden">
              <AddScreenTitle
                title="Staffs"
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
              />
              <div className={mainTable.addShadowScreen}>
                <div className={mainTable.mainContentScreen}>
                  <div
                    class={
                      "block  p-4 text-base capitalize font-medium text-neutral-70"
                    }
                  >
                    Staff Details
                  </div>
                  <div className="px-4 ">
                    <hr class={mainTable.horizontalLine}></hr>
                  </div>
                  <div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                      <InputText
                        inputType="text"
                        title="Employee ID"
                        name="employeeID"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.employeeID}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={true}
                        inputClassName="w-full"
                        errorMessage={errors.employeeID}
                      />
                      <InputText
                        inputType="text"
                        title="First Name"
                        name="firstName"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.firstName}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.firstName}
                      />

                      <InputText
                        inputType="text"
                        title="Last Name"
                        name="lastName"
                        maxLength={100}
                        content={formFields.lastName}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        // errorMessage={errors.lastName}
                      />

                      <InputText
                        inputType="text"
                        title="Father's Name"
                        name="fatherName"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.fatherName}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.fatherName}
                      />

                      <RadioGroup
                        title="Gender"
                        classStar="text-red-500"
                        type="radio"
                        setName="gender"
                        selectedOptions={formFields.gender}
                        options={gender}
                        controlFunc={handleGenderChange}
                        // tabIndex="0"
                        disabled={false}
                        errorMessage={errors.gender}
                      />

                      <InputText
                        inputType="date"
                        title="Date of Birth"
                        name="dateOfBirth"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.dateOfBirth}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.dateOfBirth}
                      />

                      <InputText
                        inputType="text"
                        title="Address"
                        name="address"
                        classStar="text-red-500"
                        maxLength={200} // Increased maxLength for address (adjust as needed)
                        content={formFields.address}
                        controlFunc={handleInputChange} // Reuse existing handler
                        controlFuncBlur={handleBlur} // Reuse existing blur handler
                        disabled={false}
                        inputClassName="w-full"
                        placeholder="Enter Address"
                        // tabIndex="0"
                        errorMessage={errors.address}
                      />

                      <AutoDropDown
                        title="Country"
                        options={countryBindDD}
                        placeholder="Select Country"
                        name="country"
                        selectedOption={countryBindDD.find(
                          (x) => x.value == formFields.country
                        )}
                        Class="custom-class"
                        // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value) => {
                          const selectedCountryId = value.value;
                          const filteredStateOptions = state.filter(
                            (s) => s.countryId === selectedCountryId
                          );

                          setFormFields({
                            ...formFields,
                            country: selectedCountryId,
                            state: "",
                            city: "",
                          });

                          setFilteredStates(filteredStateOptions);
                          setFilteredCities([]); // clear city dropdown

                          setErrors({
                            ...errors,
                            country: selectedCountryId ? "" : "Select Country",
                            state: "",
                            city: "",
                          });
                        }}
                        controlFuncBlur={() => {
                          setErrors({
                            ...errors,
                            country: formFields.country ? "" : "Select Country",
                          });
                        }}
                        errorMessage={errors.country}
                      />

                      <AutoDropDown
                        title="State"
                        options={filteredStates}
                        placeholder="Select State"
                        name="state"
                        selectedOption={filteredStates.find(
                          (x) => x.value == formFields.state
                        )}
                        Class="custom-class"
                        // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value) => {
                          const selectedStateId = value.value;
                          const filteredCityOptions = cityBindDD.filter(
                            (c) => c.stateId === selectedStateId
                          );

                          setFormFields({
                            ...formFields,
                            state: selectedStateId,
                            city: "",
                          });

                          setFilteredCities(filteredCityOptions);

                          setErrors({
                            ...errors,
                            state: selectedStateId ? "" : "Select State",
                            city: "",
                          });
                        }}
                        controlFuncBlur={() => {
                          setErrors({
                            ...errors,
                            state: formFields.state ? "" : "Select State",
                          });
                        }}
                        errorMessage={errors.state}
                      />
                      <AutoDropDown
                        title="City"
                        options={filteredCities}
                        placeholder="Select City"
                        name="city"
                        selectedOption={filteredCities.find(
                          (x) => x.value == formFields.city
                        )}
                        Class="custom-class"
                        // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value) => {
                          setFormFields({
                            ...formFields,
                            city: value.value,
                          });
                          setErrors({
                            ...errors,
                            city: value.value ? "" : "Select City",
                          });
                        }}
                        controlFuncBlur={() => {
                          setErrors({
                            ...errors,
                            city: formFields.city ? "" : "Select City",
                          });
                        }}
                        errorMessage={errors.city}
                      />

                      <DropDown
                        name="bloodGroup"
                        title="Blood Group"
                        type={"select-one"}
                        classStar="text-red-500"
                        options={BloodGroup}
                        selectedOption={formFields.bloodGroup}
                        controlFunc={(e) =>
                          setFormFields({
                            ...formFields,
                            bloodGroup: e.target.value,
                          })
                        }
                        controlFuncBlur={handleBlur}
                        placeholder="Select Blood Group"
                        // tabIndex="5"
                        isRequired={true}
                        errorMessage={errors.bloodGroup}
                      />

                      <InputText
                        inputType="text"
                        title="Aadhaar Number"
                        name="aadhaarNumber"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.aadhaarNumber}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.aadhaarNumber}
                      />
                      <InputText
                        inputType="text"
                        title="PAN Number"
                        name="panNumber"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.panNumber}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.panNumber}
                      />

                      <InputText
                        inputType="text"
                        title="Contact Number"
                        name="contactNumber"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.contactNumber}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.contactNumber}
                      />

                      <InputText
                        inputType="text"
                        title="Email"
                        name="email"
                        maxLength={100}
                        content={formFields.email}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                      />

                      <InputText
                        inputType="date"
                        title="Hiring Date"
                        name="hiringDate"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.hiringDate}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.hiringDate}
                      />

                      {/* <DropDown
                                                name="idProof"
                                                title="ID Proof"
                                                type={"select-one"}
                                                classStar="text-red-800"
                                                options={idProofType}
                                                selectedOption={formFields.idProof}
                                                controlFunc={(e) =>
                                                    setFormFields({
                                                        ...formFields,
                                                        idProof: e.target.value,
                                                    })
                                                }
                                                controlFuncBlur={handleBlur}
                                                placeholder="Select ID"
                                                // tabIndex="5"
                                                isRequired={true}
                                                errorMessage={errors.idProof}
                                            />


                                            <InputText
                                                inputType="text"
                                                title="ID Number"
                                                name="idNumber"
                                                classStar="text-red-500"
                                                maxLength={100}
                                                content={formFields.idNumber}
                                                controlFunc={handleInputChange}
                                                controlFuncBlur={handleBlur}
                                                disabled={false}
                                                inputClassName="w-full"
                                                errorMessage={errors.idNumber}
                                            /> */}

                      <DropDown
                        name="position"
                        title="Position"
                        type={"select-one"}
                        options={Position}
                        classStar="text-red-500"
                        selectedOption={formFields.position}
                        controlFunc={(e) =>
                          setFormFields({
                            ...formFields,
                            position: e.target.value,
                          })
                        }
                        controlFuncBlur={handleBlur}
                        placeholder="Select Position"
                        // tabIndex="5"
                        isRequired={true}
                        errorMessage={errors.position}
                      />

                      <DropDown
                        name="workShift"
                        title="Work Shift"
                        type={"select-one"}
                        classStar="text-red-800"
                        options={shiftName}
                        selectedOption={formFields.workShift}
                        controlFunc={(e) =>
                          setFormFields({
                            ...formFields,
                            workShift: e.target.value,
                          })
                        }
                        controlFuncBlur={handleBlur}
                        placeholder="Select Shift"
                        // tabIndex="5"
                        isRequired={true}
                        errorMessage={errors.workShift}
                      />
                    </div>

                    <div className="cols-span-3 p-4">
                      <div className="mt-2">
                        <FileUpload
                          title="Image"
                          apiCall="StaffMasterAPI/StaffImageUpload"
                          classStar="text-red-500"
                          modalName="StaffImages"
                          showImage={formFields.showImage}
                          disabledBtn={updateScreenTitle}
                          showImageData={handleShowImage}
                          imageUploadedError={errors.imageUploadedError}
                          limitMassage={
                            "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                          }
                          MAX_FILE_SIZE_MB={2}
                          ALLOWED_FORMATS={[
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                          ]}
                        />
                      </div>
                    </div>

                    <div
                      class={
                        "block mb-1 p-4 text-base capitalize font-medium text-neutral-70"
                      }
                    >
                      Bank Details
                    </div>
                    <div className="px-4">
                      <hr class={mainTable.horizontalLine}></hr>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                      <InputText
                        inputType="text"
                        title="Bank Name"
                        name="bankName"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.bankName}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.bankName}
                      />
                      <InputText
                        inputType="text"
                        title="Bank Branch"
                        name="bankBranch"
                        maxLength={100}
                        content={formFields.bankBranch}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                      />
                      <InputText
                        inputType="text"
                        title="Account Number"
                        name="accountNumber"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.accountNumber}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.accountNumber}
                      />
                      <InputText
                        inputType="text"
                        title="IFSC Code"
                        name="ifscCode"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.ifscCode}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.ifscCode}
                      />
                    </div>

                    <div
                      class={
                        "block mb-1 p-4 text-base capitalize font-medium text-neutral-70"
                      }
                    >
                      Emergency Contact Details
                    </div>
                    <div className="px-4">
                      <hr class={mainTable.horizontalLine}></hr>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                      <InputText
                        inputType="text"
                        title="Emergency Contact Name"
                        name="contactName"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.contactName}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.contactName}
                      />
                      <InputText
                        inputType="text"
                        title="Relationship"
                        name="relation"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.relation}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.relation}
                      />
                      <InputText
                        inputType="text"
                        title=" Emergency Contact Number"
                        name="emergencycontactNumber"
                        classStar="text-red-500"
                        maxLength={100}
                        content={formFields.emergencycontactNumber}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        disabled={false}
                        inputClassName="w-full"
                        errorMessage={errors.emergencycontactNumber}
                      />
                    </div>
                    {/* <div className="cols-span-3 p-4">
                                            <TextArea
                                                title=" Emergency Address"
                                                rows={5}
                                                name="emergencyaddress"
                                                content={formFields.emergencyaddress}
                                                resize={false}
                                                placeholder="Enter Address"
                                                controlFunc={(e) =>
                                                    setFormFields((prev) => ({
                                                        ...prev,
                                                        emergencyaddress: e.target.value,
                                                    }))
                                                }
                                                controlFuncBlur={() => { }}
                                                disabled={false}
                                                // tabIndex="0"
                                                errorMessage=""
                                            />
                                        </div>  */}

                    {/* 
                                        {errors.salarySelection && (
                                            <div className="text-red-500 text-lg mt-1 px-4">
                                                {errors.salarySelection}
                                            </div>
                                        )}
                                        <GridPageWithCheckBox
                                            header={SalaryPayHeader}
                                            records={BindSalaryPayData}
                                            checkBoxStatus={handle1}
                                            onSelectedGrid={setSelectedRowData}
                                            isMultiSelect={false}
                                            checkBoxVisible={true}
                                            addView={true}

                                            selectedRows={selectedRows ?? []}
                                        /> */}

                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={handleCancel}
                      disabledBtn={submitBtnDisabled || isLoading}
                      viewSaveButton={false}
                      onSave={false}
                      onSaveAndProceed={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
        <MainPopup
          popUpOpen={popUpOpen}
          setpopUpOpen={setpopUpOpen}
          Open={() => setpopUpOpen(false)}
          className="fixed inset-0 flex items-center justify-center z-60"
        >
          <div>
            <PopUpScreenTitle
              title="Staff"
              setpopUpOpen={setpopUpOpen}
              viewDetails={viewDetails}
              deleteDetails={deleteDetails}
              blockDetails={blockDetails}
              unBlockDetails={unBlockDetails}
            />
            <StaffMasterPopup
              data={popUpData}
              data1={popupDataDD}
              BindSalaryPayData={BindSalaryPayData}
              selectedRows={selectedRows}
              state={state}
              countryBindDD={countryBindDD}
              cityBindDD={cityBindDD}
            />
          </div>
          <PopUpButtons
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            rowIndex={rowIndex}
            handleSubmit={handleSubmit}
            cancel={cancel}
            disabledBtn={submitBtnDisabled ? true : false}
          />
        </MainPopup>
      </MainLayout>
    </>
  );
};

export default StaffMaster;
